// @ts-nocheck 54e8ec59
import constants from '#packages/constants';

import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  allowConnectToDB: true,
  skipInQuickEditPanel: true,
  overridesWhenReferred: {
    gfpp: {
      disableActions: [constants.ROOT_COMPS.GFPP.ACTIONS.DESIGN],
    },
  },
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
